import { render } from "./SettingPage.vue?vue&type=template&id=01b4f16f"
import script from "./SettingPage.vue?vue&type=script&lang=js"
export * from "./SettingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__